import { render, staticRenderFns } from "./SocialClub.vue?vue&type=template&id=9a44221e&"
import script from "./SocialClub.vue?vue&type=script&lang=js&"
export * from "./SocialClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports